<script>
import baseMixin from '@/mixins/baseMixin'
import ownerMixin from '@/mixins/ownerMixin'

export default {
  name: 'TheOwnerDetails',
  mixins: [baseMixin, ownerMixin],
}
</script>

<template>
  <v-list
    v-if="isLoadingClientDetails"
    class="py-0"
    :width="isMobileViewPort ? '' : '280px'"
  >
    <v-list-item class="py-1">
      <v-list-item-avatar>
        <v-icon>mdi-phone</v-icon>
      </v-list-item-avatar>
      <v-list-item-content v-if="!isMobileViewPort">
        <v-list-item-title class="body-2">
          <v-skeleton-loader type="text"></v-skeleton-loader>
        </v-list-item-title>
        <v-list-item-subtitle>
          <v-skeleton-loader type="text"></v-skeleton-loader>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
  <v-list
    v-else-if="owner"
    class="py-0"
    :width="isMobileViewPort ? '' : '280px'"
  >
    <v-list-item class="py-1">
      <v-list-item-avatar>
        <v-icon>mdi-phone</v-icon>
      </v-list-item-avatar>
      <v-list-item-content v-if="!isMobileViewPort">
        <v-list-item-title class="body-2">
          <a
            class="text-decoration-none"
            :title="`tel:${ownerPhone}`"
            :href="`tel:${ownerPhone}`"
            >{{ ownerPhone }}</a
          >
        </v-list-item-title>
        <v-list-item-subtitle class="caption">
          {{ ownerName }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>
